const CALL_STATES = {
  Init: "init",
  Started: "started",
  Ringing: "ringing",
  Connected: "connected",
  Ended: "ended",
};

export default CALL_STATES;
